import NextLink from 'next/link'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {useRouter} from 'next/router'
import {addLocalePrefix} from '@/_new-code/utilities/add-locale-prefix'
import type {BlockWithClassName} from '@/_new-code/services/kontent-ai/types'

export type LinkContentItem = IContentItem<{
	text: Elements.TextElement
	url: Elements.TextElement
	icon: Elements.MultipleChoiceElement
	openInNewTab: Elements.MultipleChoiceElement
}>

export const LinkBlock: BlockWithClassName<LinkContentItem> = ({
	block: {
		elements: {openInNewTab, text, url},
	},
	className,
}) => {
	const {locale = ''} = useRouter()
	const href = addLocalePrefix(url, locale)
	const isXml = href.endsWith('.xml')
	const target = openInNewTab[0]?.codename === 'yes' ? '_blank' : '_self'
	if (isXml) {
		return (
			<a
				className={className}
				href={href}
				rel={target === '_blank' ? 'noopener noreferrer' : undefined}
				target={target}
			>
				{text}
			</a>
		)
	}
	return (
		<NextLink
			className={className}
			data-kontent-element-codename="text"
			href={href}
			passHref
			target={target}
		>
			{text}
		</NextLink>
	)
}
